import { render, staticRenderFns } from "./profitList.vue?vue&type=template&id=0542c63a&scoped=true&"
import script from "./profitList.vue?vue&type=script&lang=js&"
export * from "./profitList.vue?vue&type=script&lang=js&"
import style0 from "./profitList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./profitList.vue?vue&type=style&index=1&id=0542c63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0542c63a",
  null
  
)

export default component.exports